import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import {
  FiGrid,
  FiMap,
  FiBookOpen,
  FiCpu,
  FiMessageSquare,
} from "react-icons/fi";
import { useNavigate } from "react-router-dom";

const FloatingAdminMenu = ({ showMenu, setShowMenu }) => {
  const navigate = useNavigate();

  const menuItems = [
 
    {
      title: "Administrar Mentorías",
      icon: <FiBookOpen size={18} />,
      path: "/admin-mentorias",
    },
    {
      title: "Administrar Agente IA",
      icon: <FiCpu size={18} />,
      path: "/admin-ia",
    }, {
      title: "Administrar Meta Ads",
      icon: <FiCpu size={18} />,
      path: "/admin-meta",
    }
  ];

  return (
    <>
      {/* BOTÓN FLOTANTE */}
      <motion.button
        whileTap={{ scale: 0.9 }}
        whileHover={{ scale: 1.05 }}
        onClick={() => setShowMenu(!showMenu)}
        className="fixed bottom-6 left-6 z-[9999]
        bg-[#1a1411]/95
        border border-[#B8977F]/30
        text-[#B8977F]
        p-4 rounded-2xl
        shadow-[0_0_30px_rgba(184,151,127,0.15)]
        backdrop-blur-xl"
      >
        <FiGrid size={22} />
      </motion.button>

      {/* MENÚ */}
      <AnimatePresence>
        {showMenu && (
          <motion.div
            initial={{ opacity: 0, y: 25, scale: 0.95 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 25, scale: 0.95 }}
            transition={{ duration: 0.2 }}
            className="fixed bottom-24 left-6 z-[9999]
            w-[280px]
            bg-[#120f0d]/95
            border border-[#B8977F]/20
            rounded-3xl
            p-3
            backdrop-blur-xl
            shadow-2xl"
          >
            <div className="flex flex-col gap-2">
              {menuItems.map((item, index) => (
                <motion.button
                  key={index}
                  whileHover={{ x: 4 }}
                  onClick={() => {
                    navigate(item.path);
                    setShowMenu(false);
                  }}
                  className="
                  flex items-center gap-4
                  w-full
                  px-4 py-4
                  rounded-2xl
                  text-[#B8977F]
                  hover:text-white
                  hover:bg-[#B8977F]/10
                  transition-all duration-300
                  border border-transparent
                  hover:border-[#B8977F]/20
                  "
                >
                  <div className="text-[#B8977F]">{item.icon}</div>

                  <span className="tracking-wide text-sm md:text-base">
                    {item.title}
                  </span>
                </motion.button>
              ))}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export default FloatingAdminMenu;